var _g, _g2, _g3, _rect, _g4, _g5, _g6, _g7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g8, _g9, _g0, _g1, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_329_903)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.0859,
    y: 10.4062,
    width: 45.5625,
    height: 49.5,
    rx: 1,
    fill: "url(#paint0_linear_329_903)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.0859,
    y: 10.4062,
    width: 45.5625,
    height: 49.5,
    rx: 1,
    fill: "url(#paint1_radial_329_903)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_329_903)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.0859,
    y: 10.4062,
    width: 41.5625,
    height: 47.1875,
    rx: 1.2,
    fill: "url(#paint2_linear_329_903)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_329_903)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.0859,
    y: 4.09375,
    width: 45.5625,
    height: 49.5,
    rx: 1,
    fill: "url(#paint3_linear_329_903)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.6484,
    y: 15.5,
    width: 20.5625,
    height: 7.53125,
    rx: 1,
    fill: "url(#paint4_linear_329_903)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_329_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3516 40.4062L17.8765 41.9083C18.5167 42.0823 18.9609 42.6635 18.9609 43.3269C18.9609 44.2957 18.0401 44.9997 17.1052 44.7455L12.3516 43.4531V40.4062Z",
    fill: "url(#paint5_linear_329_903)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_329_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3516 30.2969L17.8765 31.7989C18.5167 31.973 18.9609 32.5542 18.9609 33.2175C18.9609 34.1864 18.0401 34.8903 17.1052 34.6361L12.3516 33.3438V30.2969Z",
    fill: "url(#paint6_linear_329_903)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_329_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3516 20.1875L17.8765 21.6896C18.5167 21.8636 18.9609 22.4448 18.9609 23.1081C18.9609 24.077 18.0401 24.7809 17.1052 24.5267L12.3516 23.2344V20.1875Z",
    fill: "url(#paint7_linear_329_903)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_329_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3516 9.70312L17.8765 11.2052C18.5167 11.3792 18.9609 11.9604 18.9609 12.6238C18.9609 13.5926 18.0401 14.2965 17.1052 14.0424L12.3516 12.75V9.70312Z",
    fill: "url(#paint8_linear_329_903)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12666 12.586C9.12666 10.5158 10.8049 8.8376 12.8751 8.8376C14.8383 8.8376 16.4503 10.3478 16.6104 12.2689C16.6746 13.0395 17.3513 13.612 18.1218 13.5478C18.8924 13.4836 19.4649 12.8069 19.4007 12.0364C19.1207 8.67626 16.3068 6.0376 12.8751 6.0376C9.2585 6.0376 6.32666 8.96943 6.32666 12.586C6.32666 15.9356 8.84151 18.6978 12.0861 19.0874V16.2513C10.3947 15.8889 9.12666 14.3856 9.12666 12.586Z",
    fill: "url(#paint9_linear_329_903)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12666 12.586C9.12666 10.5158 10.8049 8.8376 12.8751 8.8376C14.8383 8.8376 16.4503 10.3478 16.6104 12.2689C16.6746 13.0395 17.3513 13.612 18.1218 13.5478C18.8924 13.4836 19.4649 12.8069 19.4007 12.0364C19.1207 8.67626 16.3068 6.0376 12.8751 6.0376C9.2585 6.0376 6.32666 8.96943 6.32666 12.586C6.32666 15.9356 8.84151 18.6978 12.0861 19.0874V16.2513C10.3947 15.8889 9.12666 14.3856 9.12666 12.586Z",
    fill: "url(#paint10_radial_329_903)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12666 12.586C9.12666 10.5158 10.8049 8.8376 12.8751 8.8376C14.8383 8.8376 16.4503 10.3478 16.6104 12.2689C16.6746 13.0395 17.3513 13.612 18.1218 13.5478C18.8924 13.4836 19.4649 12.8069 19.4007 12.0364C19.1207 8.67626 16.3068 6.0376 12.8751 6.0376C9.2585 6.0376 6.32666 8.96943 6.32666 12.586C6.32666 15.9356 8.84151 18.6978 12.0861 19.0874V16.2513C10.3947 15.8889 9.12666 14.3856 9.12666 12.586Z",
    fill: "url(#paint11_radial_329_903)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12666 22.8595C9.12666 20.7893 10.8049 19.111 12.8751 19.111C14.8383 19.111 16.4503 20.6213 16.6104 22.5424C16.6746 23.3129 17.3513 23.8855 18.1218 23.8212C18.8924 23.757 19.4649 23.0803 19.4007 22.3098C19.1207 18.9497 16.3068 16.311 12.8751 16.311C9.2585 16.311 6.32666 19.2429 6.32666 22.8595C6.32666 26.209 8.84151 28.9712 12.0861 29.3609V26.5247C10.3947 26.1624 9.12666 24.659 9.12666 22.8595Z",
    fill: "url(#paint12_linear_329_903)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12666 22.8595C9.12666 20.7893 10.8049 19.111 12.8751 19.111C14.8383 19.111 16.4503 20.6213 16.6104 22.5424C16.6746 23.3129 17.3513 23.8855 18.1218 23.8212C18.8924 23.757 19.4649 23.0803 19.4007 22.3098C19.1207 18.9497 16.3068 16.311 12.8751 16.311C9.2585 16.311 6.32666 19.2429 6.32666 22.8595C6.32666 26.209 8.84151 28.9712 12.0861 29.3609V26.5247C10.3947 26.1624 9.12666 24.659 9.12666 22.8595Z",
    fill: "url(#paint13_radial_329_903)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12666 22.8595C9.12666 20.7893 10.8049 19.111 12.8751 19.111C14.8383 19.111 16.4503 20.6213 16.6104 22.5424C16.6746 23.3129 17.3513 23.8855 18.1218 23.8212C18.8924 23.757 19.4649 23.0803 19.4007 22.3098C19.1207 18.9497 16.3068 16.311 12.8751 16.311C9.2585 16.311 6.32666 19.2429 6.32666 22.8595C6.32666 26.209 8.84151 28.9712 12.0861 29.3609V26.5247C10.3947 26.1624 9.12666 24.659 9.12666 22.8595Z",
    fill: "url(#paint14_radial_329_903)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12666 33.1798C9.12666 31.1096 10.8049 29.4313 12.8751 29.4313C14.8383 29.4313 16.4503 30.9416 16.6104 32.8627C16.6746 33.6332 17.3513 34.2058 18.1218 34.1416C18.8924 34.0773 19.4649 33.4006 19.4007 32.6301C19.1207 29.27 16.3068 26.6313 12.8751 26.6313C9.2585 26.6313 6.32666 29.5632 6.32666 33.1798C6.32666 36.5293 8.84151 39.2915 12.0861 39.6812V36.845C10.3947 36.4827 9.12666 34.9793 9.12666 33.1798Z",
    fill: "url(#paint15_linear_329_903)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12666 33.1798C9.12666 31.1096 10.8049 29.4313 12.8751 29.4313C14.8383 29.4313 16.4503 30.9416 16.6104 32.8627C16.6746 33.6332 17.3513 34.2058 18.1218 34.1416C18.8924 34.0773 19.4649 33.4006 19.4007 32.6301C19.1207 29.27 16.3068 26.6313 12.8751 26.6313C9.2585 26.6313 6.32666 29.5632 6.32666 33.1798C6.32666 36.5293 8.84151 39.2915 12.0861 39.6812V36.845C10.3947 36.4827 9.12666 34.9793 9.12666 33.1798Z",
    fill: "url(#paint16_radial_329_903)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12666 33.1798C9.12666 31.1096 10.8049 29.4313 12.8751 29.4313C14.8383 29.4313 16.4503 30.9416 16.6104 32.8627C16.6746 33.6332 17.3513 34.2058 18.1218 34.1416C18.8924 34.0773 19.4649 33.4006 19.4007 32.6301C19.1207 29.27 16.3068 26.6313 12.8751 26.6313C9.2585 26.6313 6.32666 29.5632 6.32666 33.1798C6.32666 36.5293 8.84151 39.2915 12.0861 39.6812V36.845C10.3947 36.4827 9.12666 34.9793 9.12666 33.1798Z",
    fill: "url(#paint17_radial_329_903)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12666 43.4767C9.12666 41.4065 10.8049 39.7282 12.8751 39.7282C14.8383 39.7282 16.4503 41.2385 16.6104 43.1595C16.6746 43.9301 17.3513 44.5026 18.1218 44.4384C18.8924 44.3742 19.4649 43.6975 19.4007 42.927C19.1207 39.5669 16.3068 36.9282 12.8751 36.9282C9.2585 36.9282 6.32666 39.8601 6.32666 43.4767C6.32666 46.8262 8.84151 49.5884 12.0861 49.978V47.1419C10.3947 46.7796 9.12666 45.2762 9.12666 43.4767Z",
    fill: "url(#paint18_linear_329_903)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12666 43.4767C9.12666 41.4065 10.8049 39.7282 12.8751 39.7282C14.8383 39.7282 16.4503 41.2385 16.6104 43.1595C16.6746 43.9301 17.3513 44.5026 18.1218 44.4384C18.8924 44.3742 19.4649 43.6975 19.4007 42.927C19.1207 39.5669 16.3068 36.9282 12.8751 36.9282C9.2585 36.9282 6.32666 39.8601 6.32666 43.4767C6.32666 46.8262 8.84151 49.5884 12.0861 49.978V47.1419C10.3947 46.7796 9.12666 45.2762 9.12666 43.4767Z",
    fill: "url(#paint19_radial_329_903)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12666 43.4767C9.12666 41.4065 10.8049 39.7282 12.8751 39.7282C14.8383 39.7282 16.4503 41.2385 16.6104 43.1595C16.6746 43.9301 17.3513 44.5026 18.1218 44.4384C18.8924 44.3742 19.4649 43.6975 19.4007 42.927C19.1207 39.5669 16.3068 36.9282 12.8751 36.9282C9.2585 36.9282 6.32666 39.8601 6.32666 43.4767C6.32666 46.8262 8.84151 49.5884 12.0861 49.978V47.1419C10.3947 46.7796 9.12666 45.2762 9.12666 43.4767Z",
    fill: "url(#paint20_radial_329_903)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_329_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.875 37.8672C10.0316 37.8672 7.72656 35.5622 7.72656 32.7188C7.72656 29.8753 10.0316 27.5703 12.875 27.5703C15.5724 27.5703 17.7854 29.6448 18.0055 32.2854",
    stroke: "url(#paint21_radial_329_903)",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_329_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.875 27.5703C10.0316 27.5703 7.72656 25.2653 7.72656 22.4219C7.72656 19.5785 10.0316 17.2734 12.875 17.2734C15.5724 17.2734 17.7854 19.3479 18.0055 21.9885",
    stroke: "url(#paint22_radial_329_903)",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_329_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.875 17.2734C10.0316 17.2734 7.72656 14.9684 7.72656 12.125C7.72656 9.2816 10.0316 6.97656 12.875 6.97656C15.5724 6.97656 17.7854 9.05102 18.0055 11.6916",
    stroke: "url(#paint23_radial_329_903)",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_329_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.875 48.1641C10.0316 48.1641 7.72656 45.859 7.72656 43.0156C7.72656 40.1722 10.0316 37.8672 12.875 37.8672C15.5724 37.8672 17.7854 39.9416 18.0055 42.5822",
    stroke: "url(#paint24_radial_329_903)",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_329_903",
    x: 12.0859,
    y: 10.2562,
    width: 45.5625,
    height: 49.65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.823529 0 0 0 0 0.568627 0 0 0 0 0.282353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_329_903"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_329_903",
    x: 13.4859,
    y: 10.3062,
    width: 42.1625,
    height: 47.2875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.6,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.898039 0 0 0 0 0.952941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_329_903"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_329_903",
    x: 11.9859,
    y: 3.89375,
    width: 45.6625,
    height: 49.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.556863 0 0 0 0 0.152941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_329_903"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.87451 0 0 0 0 0.360784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_329_903",
    result: "effect2_innerShadow_329_903"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_329_903",
    x: 11.9516,
    y: 40.0062,
    width: 7.40938,
    height: 5.1916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_329_903"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_329_903",
    x: 11.9516,
    y: 29.8969,
    width: 7.40938,
    height: 5.1916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_329_903"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_329_903",
    x: 11.9516,
    y: 19.7875,
    width: 7.40938,
    height: 5.1916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_329_903"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_329_903",
    x: 11.9516,
    y: 9.30312,
    width: 7.40938,
    height: 5.1916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_329_903"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_329_903",
    x: 7.12661,
    y: 26.9704,
    width: 11.479,
    height: 11.4968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_329_903"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_329_903",
    x: 7.12661,
    y: 16.6735,
    width: 11.479,
    height: 11.4968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_329_903"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_329_903",
    x: 7.12661,
    y: 6.37661,
    width: 11.479,
    height: 11.4968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_329_903"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_329_903",
    x: 7.12661,
    y: 37.2672,
    width: 11.479,
    height: 11.4968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_329_903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_329_903",
    x1: 59.5234,
    y1: 57.7812,
    x2: 40.3984,
    y2: 57.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AC294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CD6B8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_329_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.1484 51.6562) rotate(90) scale(5.125 4.71733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.243902,
    stopColor: "#2DD1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD1A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_329_903",
    x1: 34.8672,
    y1: 53.4063,
    x2: 34.8672,
    y2: 57.5937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1B0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_329_903",
    x1: 34.8672,
    y1: 4.09375,
    x2: 34.8672,
    y2: 53.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BEAC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AE6C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_329_903",
    x1: 34.9297,
    y1: 17.0898,
    x2: 34.9297,
    y2: 23.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3CF72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3DC8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_329_903",
    x1: 18.0859,
    y1: 44.4688,
    x2: 7.39844,
    y2: 41.2187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231455,
    stopColor: "#28B793",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBAB35",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_329_903",
    x1: 18.0859,
    y1: 34.3594,
    x2: 7.39844,
    y2: 31.1094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231455,
    stopColor: "#28B793",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8AD2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_329_903",
    x1: 18.0859,
    y1: 24.25,
    x2: 7.39844,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231455,
    stopColor: "#28B793",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8AD2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_329_903",
    x1: 18.0859,
    y1: 13.7656,
    x2: 7.39844,
    y2: 10.5156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231455,
    stopColor: "#28B793",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6B32C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_329_903",
    x1: 12.8661,
    y1: 6.0376,
    x2: 12.8661,
    y2: 19.1345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A498AD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_329_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8661 12.5625) rotate(-95.4788) scale(5.50189 6.20202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.402522,
    stopColor: "#B8A5BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8A5BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_329_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0236 10.625) rotate(119.954) scale(8.51194 7.89149)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.707753,
    stopColor: "#AA9DB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D7F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_329_903",
    x1: 12.8661,
    y1: 16.311,
    x2: 12.8661,
    y2: 29.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A498AD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_329_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8661 22.8359) rotate(-95.4788) scale(5.50189 6.20202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.402522,
    stopColor: "#B8A5BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8A5BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_329_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0236 20.8984) rotate(119.954) scale(8.51194 7.89149)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.707753,
    stopColor: "#AA9DB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D7F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_329_903",
    x1: 12.8661,
    y1: 26.6313,
    x2: 12.8661,
    y2: 39.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A498AD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_329_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8661 33.1563) rotate(-95.4788) scale(5.50189 6.20202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.402522,
    stopColor: "#B8A5BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8A5BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_329_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0236 31.2188) rotate(119.954) scale(8.51194 7.89149)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.707753,
    stopColor: "#AA9DB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D7F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_329_903",
    x1: 12.8661,
    y1: 36.9282,
    x2: 12.8661,
    y2: 50.0251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A498AD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_329_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8661 43.4531) rotate(-95.4788) scale(5.50189 6.20202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.402522,
    stopColor: "#B8A5BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8A5BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_329_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0236 41.5156) rotate(119.954) scale(8.51194 7.89149)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.707753,
    stopColor: "#AA9DB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D7F98"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_329_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8359 27.2187) rotate(119.56) scale(4.81412 6.56272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDD7DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_329_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8359 16.9219) rotate(119.56) scale(4.81412 6.56272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDD7DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_329_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8359 6.625) rotate(119.56) scale(4.81412 6.56272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDD7DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_329_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8359 37.5156) rotate(119.56) scale(4.81412 6.56272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDD7DD",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBook);
export default __webpack_public_path__ + "static/media/ic_book.24706d455f7256bc7f9c65e5216e43f4.svg";
export { ForwardRef as ReactComponent };